<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHinge from "../DesignerQuestionHardwareHinge.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHinge
        ],
        props: {
            title: {
                default() {
                    return 'Select A Hinge'
                }
            }
        },
    }
</script>
